import { CHAINS } from 'consts';
import { TokenInfo } from 'types';
import { GalaxyConfig } from 'types/galaxy';

export const CT_CHAINS = [CHAINS.polygon.id];
export const CT_CHAIN_ID = CHAINS.polygon.id;

export const CT_TOKEN: TokenInfo = {
  address: '0x2791bca1f2de4661ed88a30c99a7a9449aa84174',
  symbol: 'USDC.e',
  name: 'USD Coin',
  decimals: 6,
  chainId: 137,
  logoURI: '',
  tags: ['hasLogo'],
};

export const CT_API_URL = import.meta.env.VITE_CT_API_URL || 'https://sniper-api.wowmax.exchange';
export const COPY_BOT_API_URL = import.meta.env.VITE_COPY_BOT_API_URL || 'http://localhost:3000';

export const MEME_API_URL = 'https://trading.wowmax.exchange/four-meme';

export const GALAXY_API_URL = 'https://sniper-api.wowmax.exchange/galaxy';

export const GECKO_ID: Record<number, string> = {
  [CHAINS.polygon.id]: 'polygon_pos',
};

export const DEFAULT_CAP = 0.005;

export const GALAXY_CONFIG: GalaxyConfig = {
  starCount: 3000, // Will be overridden by API data
  galaxyRadius: 80,
  arms: 5,
  armCurve: 2.5,
  thickness: 4,
  coreSize: 8,
  bloomStrength: 1.4,
  bloomRadius: 0.4,
  bloomThreshold: 0.4,
};
